// Module
var code = "<div ng-if=vm.loading layout=column layout-align=\"center center\" class=\"gz-view-container landing-page-container\"><pros-spinner mode=printos></pros-spinner></div><div ng-if=!vm.loading class=\"gz-view-container landing-page-container\"><hm-lp2></hm-lp2></div>";
// Exports
module.exports = code;